import { ContentSwitcher, Label } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { useLocale } from 'hooks/useLocale';
import { TTermLength } from 'lendingApi/lendingApi.types';
import { TCalculatorProducts } from 'types';
import { DURATIONS } from '../filterConfigs.helper';
import styles from './ProductFilter.module.css';

type TProps = {
  value: number;
  onChange: (product: TCalculatorProducts, term: TTermLength) => void;
};

export const ProductFilter = ({
  value: selectedDuration,
  onChange,
}: TProps) => {
  const { isDE } = useLocale();

  const handleSelected = (duration: TTermLength) => {
    onChange(
      // Only set flexi24 product if UK and 24 month duration
      duration === 24 && !isDE ? 'flexi24' : 'credit_facility',
      duration,
    );
  };

  return (
    <div className={styles.container}>
      <Label className={styles.label}>
        <Trans>Term length</Trans>
      </Label>
      <div id="term-lengths">
        <ContentSwitcher value={selectedDuration.toString()}>
          {DURATIONS.map((maxTermLength) => (
            <ContentSwitcher.Button
              key={maxTermLength}
              className={styles.button}
              id={maxTermLength.toString()}
              setSelected={(id) => handleSelected(Number(id) as TTermLength)}
            >
              <Trans>{maxTermLength} months</Trans>
            </ContentSwitcher.Button>
          ))}
        </ContentSwitcher>
      </div>
    </div>
  );
};
